"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.floorUtcHour = floorUtcHour;
exports.floorUtcDay = floorUtcDay;
exports.addUtcMonths = addUtcMonths;
const DAY_MS = 24 * 60 * 60 * 1000;
function floorUtcHour(date) {
    const floored = new Date(date);
    floored.setUTCMinutes(0, 0, 0);
    return floored;
}
function floorUtcDay(date) {
    return new Date(Math.floor(date.getTime() / DAY_MS) * DAY_MS);
}
function addUtcMonths(date, months) {
    const result = new Date(date);
    const day = result.getUTCDate();
    result.setUTCDate(1);
    result.setUTCMonth(result.getUTCMonth() + months);
    const lastDay = new Date(Date.UTC(result.getUTCFullYear(), result.getUTCMonth() + 1, 0)).getUTCDate();
    result.setUTCDate(Math.min(day, lastDay));
    return result;
}
//# sourceMappingURL=DateUtils.js.map